<template>
  <div class="footer">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12" :md="6" :lg="6"  style="text-align: center">
        <img class="QRcode" src="../assets/image/QRcode.jpg" alt />
      </el-col>
      <el-col :xs="24" :sm="12" :md="18" :lg="18" >
        <div class="rightContent">
           <div class="contact">
          <div class="cn">联系电话</div>
          <div class="con">400-1875-066</div>
        </div>
        <div class="address">
          地址：广州市天河区黄埔大道西366号1403室
        </div>

        <div class="otherInfo">
          <div style="margin-top: 20px">
            蓝居饰一直以“诚信为本、质量第一、服务至上”的方针积极开拓市场。竭诚欢迎大家莅临参观考察，洽谈合作。
          </div>
          <div>
            <ul class="routerLinks">
            <li>
              <router-link to="/">首页</router-link>
            </li>
            <li>
              <router-link to="/about">关于我们</router-link>
            </li>
            <li>
              <router-link to="/news">新闻动态</router-link>
            </li>
            <li>
              <router-link to="/product">产品展示</router-link>
            </li>
            <li>
              <router-link to="/knowledge">知识分享</router-link>
            </li>
            
          </ul>
          </div>
        </div>
        </div>
        
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
};
</script>

<style lang="scss" scoped>
.footer {
  //background-color: #aaa;
  width: 100%;
  max-width: 1200px;
  margin: auto;
  .el-row{
    margin-left: 0px; 
    margin-right: 0px;
  }
  .QRcode {
    width: 100%;
    max-width: 200px;
    margin: auto;
  }
  .rightContent{
    padding: 0 20px;
  }
  .contact {
    .cn {
      //font-size: 12px;
      margin-bottom: 8px;
      margin-top: 10px;
    }
    .con {
      font-size: 32px;
      font-weight: bold;
      color: #0c1f2d;
      margin-bottom: 4px;
    }
  }
  .address{

  }
  .routerLinks {
    list-style: none;
    height: 20px;
    margin-top: 20px;
    li {
      float: left;
      margin-right: 12px;
     font-size: 12px;
      a {
        text-decoration: none;
        color: #0c1f2d;
      }
    }
  }
  .otherInfo {
    margin-top: 20px;
    a {
      text-decoration: none;
      color: #0c1f2d;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue